// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___3mGGY","avatar":"styles__avatar___s3nV0","blank":"styles__blank___2C1Gp","rotate":"styles__rotate___3We42","fadein":"styles__fadein___36hnT","slideFromRight":"styles__slideFromRight___26d4U","waves":"styles__waves___2jYYp"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/ProfilePicture/styles.scss
// module id = ./resources/assets/js/components/ProfilePicture/styles.scss
// module chunks = 0